let order = require('../../../actions/order');
let utils = require('../../../actions/utils');
let redirect = require('../../../actions/redirect');
let account = require('../../../actions/account/orders');
let user = require('../../../actions/user');

module.exports = {
    createOrderAfterLoginIfNeededOrRedirect: [
        [
            order.shouldCreateOrderAfterLogin,
            {
                yes: [
                    utils.getItemFromLocalStorage('selected_params', 'selectedParameters'),
                    {
                        success: [
                            order.fillOrderCreationParameters,
                            [
                                order.createOrder,
                                {
                                    success: [
                                        order.removeSavedSelectedParams,
                                        account.removeLocalChanges,
                                        order.setShouldCreateOrderAfterLogin(false),
                                        utils.set(['account', 'orders', 'list'], {}),
                                        utils.set(['account', 'orders', 'list', 'isAllLoaded'], false),
                                        order.orderCreatedRedirect
                                    ],
                                    unauthorized: [
                                        order.setShouldCreateOrderAfterLogin(true),
                                        redirect.redirect('/login')
                                    ],
                                    error: [
                                        order.setShouldCreateOrderAfterLogin(false),
                                        redirect.redirectToRoot
                                    ]
                                }
                            ]
                        ],
                        notExists: [
                            redirect.redirectToRoot
                        ],
                        unavailable: [
                            redirect.redirectToRoot
                        ]
                    }
                ],
                no: [
                    [
                        utils.tryGetArgFromCookie('orderId'),
                        {
                            success: [
                                [
                                    user.isManager,
                                    {
                                        true: [
                                            redirect.locationRedirectToOrder('/manager/orders/', 'orderId')
                                        ],
                                        false: [
                                            redirect.locationRedirectToOrder('/account/orders/', 'orderId')
                                        ]
                                    }
                                ],
                                utils.unsetCookie('orderId')
                            ],
                            fail: [
                                redirect.redirectToRoot
                            ]
                        }
                    ]
                ]
            }
        ]
    ]
};



// WEBPACK FOOTER //
// ./signals/groups/auth/index.js